"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("../../Text"));

var _Flex = _interopRequireDefault(require("../../../Layout/Flex"));

var _Option = _interopRequireDefault(require("./Option"));

var Styled = _interopRequireWildcard(require("./Select.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // eslint-disable-next-line max-lines-per-function


var Select = function Select(_a) {
  var id = _a.id,
      icon = _a.icon,
      field = _a.field,
      name = _a.name,
      value = _a.value,
      className = _a.className,
      openIcon = _a.openIcon,
      props = (0, _tslib.__rest)(_a, ["id", "icon", "field", "name", "value", "className", "openIcon"]);
  var m = props.m,
      mt = props.mt,
      mb = props.mb,
      ml = props.ml,
      mr = props.mr,
      mx = props.mx,
      my = props.my,
      margin = props.margin,
      marginTop = props.marginTop,
      marginRight = props.marginRight,
      marginBottom = props.marginBottom,
      marginLeft = props.marginLeft,
      borderColor = props.borderColor,
      borderWidth = props.borderWidth,
      color = props.color,
      width = props.width,
      bg = props.bg,
      backgroundColor = props.backgroundColor,
      fontSize = props.fontSize,
      flex = props.flex,
      order = props.order,
      alignSelf = props.alignSelf,
      rest = (0, _tslib.__rest)(props, ["m", "mt", "mb", "ml", "mr", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "borderColor", "borderWidth", "color", "width", "bg", "backgroundColor", "fontSize", "flex", "order", "alignSelf"]);
  var boxProps = {
    m: m,
    mt: mt,
    mb: mb,
    ml: ml,
    mr: mr,
    mx: mx,
    my: my,
    margin: margin,
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    borderColor: borderColor,
    borderWidth: borderWidth,
    color: color,
    width: width,
    bg: bg,
    backgroundColor: backgroundColor,
    fontSize: fontSize,
    flex: flex,
    order: order,
    alignSelf: alignSelf
  };
  var selectProps = (0, _tslib.__assign)({
    color: color
  }, rest);
  return _react.default.createElement(Styled.VisualSelect, (0, _tslib.__assign)({}, boxProps, {
    className: className
  }), icon && _react.default.createElement(_Flex.default, {
    alignItems: "center",
    pl: 4
  }, icon), _react.default.createElement(Styled.TrueSelect, (0, _tslib.__assign)({
    id: id,
    role: "select"
  }, field, {
    name: field && field.name || name,
    value: field && field.value || value
  }, selectProps)), openIcon ? openIcon : _react.default.createElement(_Text.default, {
    color: props.arrowColor
  }, _react.default.createElement(Styled.OpenIcon, null)));
};

Select.Option = _Option.default;
var _default = Select;
exports.default = _default;